<template>
  <div>
    <h2 class="col-lg-12 text-center mb-3">{{ $t('edit') }}</h2>
    <KeyValueForm :baseKeyValue="keyValue" :baseKeyValueTitle="keyValueTitle" :loading="loading" @submit-requested="submitRequested"></KeyValueForm>
  </div>
</template>
 
<script>
import { mapState, mapActions } from 'vuex'
import KeyValueForm from './KeyValueForm.vue'

export default {
  components: { KeyValueForm },
  data() {
    return {
      keyValue: null,
      keyValueTitle: null,
      loading: false
    }
  },
  computed: {
    ...mapState('keyValues', ['getKeyValueByIdOutput']),
    ...mapState('keyValues', ['putKeyValueOutput'])
  },
  mounted: function() {
    this.loadKeyValue();
  },
  methods: {
    ...mapActions('keyValues', ['getKeyValueById']),
    ...mapActions('keyValues', ['putKeyValue']),
    loadKeyValue() {
      const id = this.$route.query.id;
      if (id) {
        this.loading = true;
        this.getKeyValueById(id);
      }
    },
    submitRequested (input) {
      this.putKeyValue(input);
    }
  },
  watch: {
    getKeyValueByIdOutput: function() {
      if (this.getKeyValueByIdOutput && this.getKeyValueByIdOutput.succeeded) {
        // Transform API data to match KeyValue class structure
        const apiData = this.getKeyValueByIdOutput.data;
        const keyValueData = {
          id: apiData.id,
          key: apiData.key,
          values: {
            1: apiData.values.pt || '', // Portuguese
            2: apiData.values.en || '', // English
            3: apiData.values.es || ''  // Spanish
          }
        };
        this.keyValue = keyValueData;
        this.keyValueTitle = keyValueData.key;
        this.loading = false;
      }
    }
  }
}
</script> 
 
<style scoped>
thead > tr > th
{
  text-align: unset !important;
}
</style>
